import { render } from "./SectionTitle.vue?vue&type=template&id=af6d4d54&ts=true"
import script from "./SectionTitle.vue?vue&type=script&lang=ts"
export * from "./SectionTitle.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__